import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { Module } from '../Module';
import { GridRow } from '../GridRow';
import { ButtonWrap } from './partials';
var IconCards = function IconCards(props) {
  return React.createElement(Module, {
    className: props.className
  }, React.createElement(GridRow, {
    align: "stretch",
    stack: "tablet"
  }, props.children), React.createElement(ButtonWrap, null, React.createElement(Button, _extends({
    secondary: true,
    width: "auto"
  }, props.linkProps || {}), props.buttonText)));
};
export default IconCards;